import { Col, Row, cn } from '@rematter/ui-web';

import { AssistantEventDetail } from './AssistantEventDetail';
import { AssistantEventsList } from './AssistantEventsList';
import { AssistantEventsSidebar } from './AssistantEventsSidebar';

import { useAssistantAuditTab } from '@/audit-log/_state/assistantEvents.state';
import { useTranslations } from '@/audit-log/i18n/useTranslations';

//
// ⚛️ ⚛️ ⚛️ ASSISTANT EVENTS VIEW ⚛️ ⚛️ ⚛️
//
export const AssistantEventsView = () => {
  const t = useTranslations();

  // Atoms
  const [tab, setTab] = useAssistantAuditTab();

  return (
    <Col className="@AssistantEventsView size-full">
      <Row className="border-b border-neutral/10 px-4">
        <button
          onClick={() => setTab('events')}
          className={cn(
            'px-4 py-3 text-sm font-medium transition-colors',
            tab === 'events' && 'border-b-2 border-primary text-primary',
            tab !== 'events' && 'text-neutral/60 hover:text-neutral',
          )}
        >
          {t.assistantEventsView.tabs.events}
        </button>
        <button
          onClick={() => setTab('inbox')}
          disabled
          className={cn(
            'px-4 py-3 text-sm font-medium transition-colors',
            tab === 'inbox' && 'border-b-2 border-primary text-primary',
            tab !== 'inbox' && 'cursor-not-allowed text-neutral/30',
          )}
        >
          {t.assistantEventsView.tabs.inbox}
        </button>
      </Row>
      <Row className="flex-1 items-stretch overflow-hidden">
        <AssistantEventsSidebar />
        <AssistantEventsList />
        <AssistantEventDetail />
      </Row>
    </Col>
  );
};
